var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOurFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.39746 15.9538H9.96889L13.1832 10.5752L16.3975 22.3609L20.6832 15.9538H29.2546",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6905 9.50403C26.5104 7.2452 24.734 5.35281 22.5543 4.03232C20.3746 2.71182 17.8747 2.01367 15.3262 2.01367C12.7777 2.01367 10.2778 2.71182 8.09811 4.03232C5.91837 5.35281 4.14202 7.2452 2.96191 9.50403",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96191 22.3613C4.14202 24.6202 5.91837 26.5125 8.09811 27.833C10.2778 29.1535 12.7777 29.8517 15.3262 29.8517C17.8747 29.8517 20.3746 29.1535 22.5543 27.833C24.734 26.5125 26.5104 24.6202 27.6905 22.3613",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.326172 0.932617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurFeature3);
export default __webpack_public_path__ + "static/media/icon-our-feature-3.bdc0f87720c0f48b7ab8a2e842bc0480.svg";
export { ForwardRef as ReactComponent };